// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W7f2","question":"styles_question__3UY2p","description":"styles_description__1kiRJ"};